<template>
    <v-layout row wrap >
        <v-flex xs12>
            <div class="d-inline">
                <h2 class="grupo_titulo d-inline">
                    {{ grupoLista.nombre }}
                </h2>

                <v-menu offset-y>
                    <v-btn icon class="d-inline grupo_flecha" slot="activator">
                        <v-icon small>keyboard_arrow_down</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile @click="borrarG({ id: grupoLista.id, nombre: grupoLista.nombre, idG: grupoLista.id })">
                            Borrar
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-flex>
        <v-flex xs12>
            <v-layout row wrap>
                <v-flex xs12 md4
                        class="text-xs-center"
                        v-for="(baseGrid, id) in basesDeGrupo(grupoLista.id)"
                        :key="id"
                        v-if="basesDeGrupo(grupoLista.id) && Object.keys(basesDeGrupo(grupoLista.id)).length && baseGrid">
                    <BaseGrid :baseGrid="baseGrid" :idGrupo="grupoLista.id" />
                </v-flex>
                <v-flex xs12 md4 class="text-xs-center">
                    <v-list>
                        <v-list-tile avatar>
                            <v-list-tile-content>
                                <v-text-field label="Nombre de la Base" v-model="nuevaBase[grupoLista.id]"
                                              style="width: 100%;"
                                              color="black"
                                              @keyup.enter="agregar({grupo: grupoLista.id})"></v-text-field>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-icon light @click="agregar({grupo: grupoLista.id})">add_circle</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import BaseGrid from '../../components/bases/BaseGrid'

  export default {
    name: 'grupoLista',
    props: ['grupoLista'],
    data: function () {
      return {
        nuevaBase: [],
      }
    },
    components: { BaseGrid },
    computed: {
      ...mapState({ bases: state => state.bases })
    },
    methods: {
      ...mapActions('bases', ['agregarBase', 'borrarBase', 'borrarGrupo']),
      basesDeGrupo (idG) {
        let filtradas = []
        this.bases.bases.find(function (base) {
          if(base) {
            if(base.grupo === parseInt(idG)) {
              filtradas.push(base)
            }
          }
        })
        return filtradas
      },
      agregar (params) {
        this.agregarBase({nombre: this.nuevaBase[params.grupo], grupo: params.grupo})
        this.nuevaBase[params.grupo] = ''
      },
      borrarG (params) {
        this.borrarGrupo(params)
      },
      borrar (params) {
        this.borrarBase(params)
      }
    }
  }
</script>